import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut, User as UserIcon, Sparkles } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const linkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors ${isActive ? "text-gold" : "text-white/70 hover:text-gold"}`;

  return (
    <header className="sticky top-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md flex items-center justify-center" style={{background:"linear-gradient(135deg,#FFD700,#A8861E)"}}>
            <Sparkles className="w-4 h-4 text-black" />
          </div>
          <span className="font-heading text-xl tracking-tight">
            Xook<span className="gold-text font-bold">Pub</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/studio/flyer" data-testid="nav-flyer" className={linkCls}>Flyer IA</NavLink>
          <NavLink to="/studio/video" data-testid="nav-video" className={linkCls}>Vidéo IA</NavLink>
          <NavLink to="/studio/voice" data-testid="nav-voice" className={linkCls}>Voix Off</NavLink>
          <NavLink to="/studio/composer" data-testid="nav-composer" className={linkCls}>Assembleur</NavLink>
          {user && <NavLink to="/studio/agency" data-testid="nav-agency" className={linkCls}>Agence</NavLink>}
          <NavLink to="/pricing" data-testid="nav-pricing" className={linkCls}>Tarifs</NavLink>
          {user && <NavLink to="/dashboard" data-testid="nav-dashboard" className={linkCls}>Dashboard</NavLink>}
          {user?.is_admin && (
            <NavLink to="/admin/stats" data-testid="nav-admin" className={linkCls}>Admin</NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full border border-gold/30">
                <span className="label-mono">{user.credits ?? 0} crédits</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <div className="w-8 h-8 rounded-full bg-gold/15 text-gold flex items-center justify-center">
                  <UserIcon className="w-4 h-4" />
                </div>
                <span className="hidden sm:inline text-white/90">{user.name?.split(" ")[0]}</span>
              </div>
              <button data-testid="nav-logout" onClick={logout} className="ghost-btn !py-1.5 !px-3 text-sm">
                <LogOut className="w-3.5 h-3.5" />
              </button>
            </>
          ) : (
            <>
              <button data-testid="nav-login-btn" onClick={() => navigate("/login")} className="text-sm text-white/80 hover:text-gold">Connexion</button>
              <button data-testid="nav-signup-btn" onClick={() => navigate("/login?mode=signup")} className="gold-btn !py-2 !px-4 text-sm">Commencer</button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
